import Jimp from 'jimp'
import axios from 'axios'
import * as types from '../mutation-types'

import {
  randomString,
} from '../../plugins/helper'

// state
export const state = {
  loading: true,
  filesJimp: [],
  error: null,
  records: [],
  loadingFiles: false,
  files: [],
  errorFiles: null,
}

// mutations
export const mutations = {
  [types.GET_JIMP_START](state) {
    state.loading = true
    state.filesJimp = []
    state.error = null
    state.records = []
  },

  [types.GET_JIMP_SUCCESS](state, { data, loading }) {
    state.loading = loading
    state.filesJimp.push(data)
    state.error = null
    state.records = []
  },

  [types.GET_JIMP_ERROR](state, { error }) {
    state.loading = false
    state.filesJimp = []
    state.error = error
    state.records = []
  },

  [types.GET_JIMP_RECORDS_START](state) {
    state.records = []
  },

  [types.GET_JIMP_RECORDS](state, { data }) {
    state.records = data
  },

  [types.GET_FILES_START](state) {
    state.loadingFiles = true
    state.files = []
    state.errorFiles = null
    state.records = []
  },

  [types.GET_FILES_SUCCESS](state, { data, loading }) {
    state.loadingFiles = loading
    state.files = data
    state.errorFiles = null
    state.records = []
  },

  [types.GET_FILES_ERROR](state, { error }) {
    state.loadingFiles = false
    state.files = []
    state.errorFiles = error
    state.records = []
  },
}

const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}

export const actions = {
  async alterWithJimp({ commit }, { files, attributes }) {
    commit(types.GET_JIMP_START)

    try {
      const typeImg = ['image/x-png', 'image/png', 'image/jpeg', 'image/pjpeg']
      const length = Object.keys(files).length - 1
      const jimpReadPromises = []

      if (files.length > 0) {
        let index = 0
        Object.keys(files).forEach(async key => {
          const file = files[key]
          if (typeImg.indexOf(file.type) !== -1) {
            const url = URL.createObjectURL(file)
            jimpReadPromises.push(Jimp.read(url))
          } else {
            const loading = !(length === index)
            commit(types.GET_JIMP_SUCCESS, { data: { file, key, attributes }, loading })
            index++
          }
        })

        if (jimpReadPromises.length > 0) {
          Promise.all(jimpReadPromises)
            .then(loadedimgs => {
              loadedimgs.map((image, key) => {
                image.scaleToFit(1000, 1000)
                image.quality(100)
                image.getBase64(
                  Jimp.AUTO,
                  (err, data) => {
                    if (err) {
                      commit(types.GET_JIMP_ERROR, { error: err })
                    } else {
                      const length = Object.keys(loadedimgs).length - 1
                      const loading = !(length === parseInt(key))
                      const newFile = dataURLtoFile(data, randomString(10))
                      commit(types.GET_JIMP_SUCCESS, { data: { file: newFile, key, attributes }, loading })
                    }
                  },
                )
              })
            })
        }
      } else {
        commit(types.GET_JIMP_ERROR, { error: {} })
      }
    } catch (error) {
      commit(types.GET_JIMP_ERROR, { error })
    }
  },
  async loadFullFile({ commit }, payload) {
    commit(types.GET_JIMP_RECORDS, { data: payload })
  },
  async getFiles({ commit }, { id, reference }) {
    try {
      commit(types.GET_JIMP_START)
      const { data } = await axios.get(`/api/files/${id}/${reference}`)
      commit(types.GET_FILES_SUCCESS, { data })
    } catch (error) {
      commit(types.GET_JIMP_ERROR, { error })
    }
  },
}

// getters
export const getters = {
  loadingJimp: state => state.loading,
  filesJimp: state => state.filesJimp,
  errorJimp: state => state.error,
  recordsJimp: state => state.records,
  loadingFiles: state => state.loadingFiles,
  files: state => state.files,
  errorFiles: state => state.errorFiles,
}
